import { render, staticRenderFns } from "./AddEditWorktype.vue?vue&type=template&id=4a9097c0"
import script from "./AddEditWorktype.vue?vue&type=script&lang=js"
export * from "./AddEditWorktype.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports